import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/logo.png"
      width="200px"
      {...props}
    />
  );
}

export default Logo;
